import * as React from "react";
import { Checkbox } from "react-ui";
import ReactMarkdown from "react-markdown";

import { PicklistDataItem } from "../../../../../../Engine/Core/Picklists/PicklistTypes";
import { PicklistColumn } from "../PicklistColumn";

import { Cell, Cells, Root } from "./PicklistItem.styles";

export interface PicklistItemProps {
    focused: boolean;
    columns: PicklistColumn[];
    item: PicklistDataItem;
    checkable: boolean;
    isCurrentValue?: boolean;
    onSelect: (item: PicklistDataItem, checked?: boolean) => void;
    onMouseDown?: (item: PicklistDataItem) => void;
}

export const PicklistItem = React.memo(
    React.forwardRef((props: PicklistItemProps, ref: React.Ref<HTMLDivElement>) => {
        const handleClickInMarkdown = (e: React.MouseEvent) => {
            if (e.target instanceof HTMLElement && e.target.tagName === "A") {
                e.stopPropagation();
            }
        };

        const cells = props.columns.map(column => (
            <Cell width={column.width} key={column.fieldName} onClick={handleClickInMarkdown}>
                {column.markdown ? (
                    <ReactMarkdown linkTarget={"_blank"}>
                        {props.item[column.fieldName]?.toString() ?? ""}
                    </ReactMarkdown>
                ) : (
                    (props.item[column.fieldName] ?? "")
                )}
            </Cell>
        ));

        return (
            <Root ref={ref} onMouseDown={() => props.onMouseDown?.(props.item)}>
                {props.checkable ? (
                    <Checkbox
                        tabIndex={-1}
                        checked={props.isCurrentValue}
                        onChange={() => props.onSelect(props.item, !props.isCurrentValue)}>
                        <Cells>{cells}</Cells>
                    </Checkbox>
                ) : (
                    <div onClick={() => props.onSelect(props.item)}>{cells}</div>
                )}
            </Root>
        );
    })
);

PicklistItem.displayName = "PicklistItem";
